import React from 'react'
import MListItem from '../../atom/mListItem';
import MListItemIcon from '../../atom/mListItemIcon';
import MListItemText from '../../atom/mListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

export default function ToggleButton(props) {
    const { icon: Icon, label, iconClass, listItemClass, isOpen, handleClick } = props;
    return (
        <MListItem button key={label} className={listItemClass} onClick={handleClick}>
            <MListItemIcon>
                <Icon className={iconClass} />
            </MListItemIcon>
            <MListItemText>{label}</MListItemText>
            {isOpen ? <ExpandLess /> : <ExpandMore />}
        </MListItem>
    )
}
